"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTranslationsWithoutNamespaces = void 0;
/**
 * A utility type that extracts keys from each namespace in a collection of translations with namespaces.
 * It returns a union of all keys present in the namespaces.
 *
 * @typeParam T Type representing translations with namespaces.
 */

/**
 * A utility type that extracts keys from a collection of translations with namespaces.
 * It uses the `NamespaceKeys` utility type to get a union of keys from all namespaces.
 *
 * @typeParam T Type representing translations with namespaces.
 */

/**
 * Represents the result type of the `getTranslationsWithoutNamespaces` function.
 * It maps the extracted keys from translations with namespaces to corresponding string values.
 *
 * @typeParam T Type representing translations with namespaces.
 */

/**
 * Extracts translations without namespaces from a collection of translations with namespaces.
 *
 * @typeParam T  Type representing translations with namespaces.
 * @param translationsWithNamespaces The collection which consists of namespaces and its key, value definition.
 * @returns flattened keys of each namespace as object.
 */
const getTranslationsWithoutNamespaces = translationsWithNamespaces => {
  let translationsWithoutNamespaces = {};
  for (const namespace in translationsWithNamespaces) {
    if (Object.prototype.hasOwnProperty.call(translationsWithNamespaces, namespace)) {
      const namespaceTranslations = translationsWithNamespaces[namespace];
      for (const key in namespaceTranslations) {
        if (Object.prototype.hasOwnProperty.call(namespaceTranslations, key)) {
          const value = namespaceTranslations[key];
          if (typeof value === 'string') {
            translationsWithoutNamespaces = {
              ...translationsWithoutNamespaces,
              [key]: value
            };
          }
        }
      }
    }
  }
  return translationsWithoutNamespaces;
};
exports.getTranslationsWithoutNamespaces = getTranslationsWithoutNamespaces;
